import {reduce} from 'lodash';
import { getDomain, domainCookies } from './dom';

export function setCookie({ name, value, expirationInSeconds = 0 }) {
  let expires = '';

  const date = new Date();
  const domain = getDomain(document);

  if (expirationInSeconds) {
    date.setTime(date.getTime() + (expirationInSeconds * 1000));
    expires = `;expires=${date.toGMTString()}`;
  }

  domainCookies(`${name}=${value}${expires};path=/;domain=${domain};`);
}

export function getCookie(name) {
  const allDomainCookies = domainCookies().split(';');

  for (let cookie of allDomainCookies) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(`${name}=`) === 0) {
      return cookie.substring(`${name}=`.length, cookie.length);
    }
  }

  return null;
}

export function removeCookie(name) {
  setCookie({ name: name, value: '', expirationInSeconds: -1e5 });
}

/*
 * Used on `gulp dev` only. When we're server-side rendering, we rely on
 * Express's `cookie-parser` middleware to create the `req.cookies` object
 * that we then pass into the store. But on `gulp dev`, we have to manually
 * create this object in a couple of places (client.js, loadCssOnDev.js).
 */
export const createCookiesObjectOnDev = () =>
  reduce(
    document.cookie.split('; '),
    (acc, cookiePair) => { // a `cookiePair` looks like "foo=bar"
      const [key, value] = cookiePair.split('=');
      acc[key] = value;
      return acc;
    },
    {}
  );
